<template>
  <div>
    <date-picker
      auto-submit
      v-model="Date"
      :min="minDate"
      :label="label"
      :disabled="isDisabled"
    ></date-picker>
  </div>

</template>

<script>
  export default {
    name: 'CustomDatePicker',
    props: {
      label: {
        type: String,
        isRequired: true,
      },
      dateType: {
        type: String,
        isRequired: true,
      },
      minDate: {
        type: String,
        isRequired: false,

      },
      isDisabled: {
        type: Boolean,
        isRequired: false,
        default() {
          return false
        }
      },
      value: {
        type: String,
        isRequired: false,
        default() {
          return ''
        }
      },
      defaultData: {
        type: [String],
        default() {
          return ''
        }
      },
      // defaultData: {
      //   type: Array,
      //   default: [],
      //   isRequired: false,
      // },
    },
    data () {
      return {
        date: '',
        searchText:'',
      }
    },
    mounted() {

    },
    computed: {

    },

    methods: {

    },
    watch: {

      value: {
        deep: true,
        immediate:true,
        handler(){
          this.$emit('input', this.date)
        }
      },

    },

  }
</script>

<style scoped>

</style>
